module.exports = __webpack_public_path__ + "img/vertical-line-post.3ba55d48.svg";